"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var request_1 = __importDefault(require("@flowio/request"));
var cache_1 = require("@flowio/cache");
var values_1 = __importDefault(require("lodash/values"));
var get_1 = __importDefault(require("lodash/get"));
var constants_1 = __importDefault(require("./constants"));
var BrowserBundleService = /** @class */ (function () {
    function BrowserBundleService() {
        this.sessionApplied = false;
        this.cache = new cache_1.SessionCache({
            storageKey: 'bundle',
        });
        this.featureCache = new cache_1.SessionCache({
            storageKey: 'features',
        });
    }
    BrowserBundleService.prototype.setCache = function (data, response) {
        this.cache.set(data, response, this.organization, this.experienceKey || 'undefined');
        this.featureCache.set(data.feature, response.features);
    };
    BrowserBundleService.prototype.applySession = function (session) {
        this.experienceKey = get_1.default(session, 'experience.key');
        this.organization = get_1.default(session, 'organization');
        this.geo = {
            country: get_1.default(session, 'geo.country.iso_3166_3'),
            currency: get_1.default(session, 'geo.currency.iso_4217_3'),
            language: get_1.default(session, 'geo.language.iso_639_2'),
            locale: get_1.default(session, 'geo.locale.id'),
        };
        this.contextId = get_1.default(session, 'context.id');
        this.sessionApplied = true;
    };
    BrowserBundleService.prototype.fetch = function (args) {
        var _this = this;
        if (args && args.session) {
            this.applySession(args.session);
        }
        if (!this.sessionApplied) {
            throw new Error('Session has not been initialized, plz initialize first.');
        }
        return new Promise(function (resolve, reject) {
            var baseUrl = constants_1.default.general.FLOW_API_HOST;
            var organizationId = _this.organization;
            var url = baseUrl + "/" + organizationId + "/bundles/browser" + (_this.contextId ? '?context=' + ("" + encodeURIComponent(_this.contextId)) : '');
            var country = _this.geo.country;
            var method = args && args.method || 'GET';
            var data = {
                feature: {
                    context: {
                        experience_key: _this.experienceKey,
                        geo: _this.geo,
                    },
                    keys: values_1.default(constants_1.default.features),
                },
                optin: {
                    country: country,
                },
                country_picker: {
                    country: country,
                },
                payment_method: _this.experienceKey ? {
                    country: country,
                    experience_key: _this.experienceKey,
                } : undefined,
            };
            var force = get_1.default(args, 'options.force');
            if (!force) {
                var cachedEntry = _this.cache.get(data, _this.organization, _this.experienceKey || 'undefined');
                if (cachedEntry) {
                    resolve(cachedEntry);
                    return;
                }
            }
            request_1.default.anonymous({
                url: url,
                data: data,
                method: method,
            }, function (status, response) {
                if (status === 200) {
                    _this.setCache(data, response);
                    resolve(response);
                }
                else {
                    reject(response);
                }
            });
        });
    };
    return BrowserBundleService;
}());
exports.default = BrowserBundleService;
//# sourceMappingURL=browser-bundle-service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/country-picker/~/@flowio/browser-bundle/dist/browser-bundle-service.js
// module id = 542
// module chunks = 0 1